module.exports = __webpack_public_path__ + "img/btm-curve-full.95c09130.png";